/* eslint-disable react/prop-types */
import React from 'react';
import Cotizador from './views/Cotizador';
import { CotizadorProvider } from './context';
import ErrorNotification from './components/ErrorNotification';
import useErrorNotification from './hooks/useErrorNotification';

const AppContent = ({ legal_url, model_url, car_id, uf_value }) => {
    const { error_notification, clearError } = useErrorNotification();

    return (
        <>
            <div id="cotizador_overlay">
                <div id="status">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <ErrorNotification 
                message={error_notification} 
                onClose={clearError}
            />
            <Cotizador legal_url_path={legal_url} model_url_path={model_url} car_id={car_id} uf_value={uf_value}/>
        </>
    );
};

const App = ({ legal_url, model_url, car_id, uf_value }) => {

    return (
        <CotizadorProvider>
            <AppContent legal_url={legal_url} model_url={model_url} car_id={car_id} uf_value={uf_value} />
        </CotizadorProvider>
    );
};

export default App;